<template>
  <div>
    <transition name="fade">
      <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
        <div class="modal-content" @click.stop>
          <img src="../img/big_icon.png" class="modal_img" />
          <span
            class="el-image-viewer__btn el-image-viewer__close"
            @click="handleClose"
            style="background: #5383e8; opacity: 1;"
          >
            <i class="el-icon-close" style="color: #fff; font-weight: bold"></i>
          </span>
          <ul class="one_info infos" v-if="l01Info" :class="{ alarm_info: l01Info.status == 1 }">
            <div class="infos_con">
              <li class="infos_item">01导线电流：{{ l01Info.currentValue || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l01Info, 'currentValue')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">01导线温度：{{ l01Info.temperature || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l01Info, 'temperature')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">
                01导线线夹状态：{{
                  l01Info.dropInfo == 0 ? '正常' : l01Info.dropInfo == 1 ? '脱落' : '-'
                }}
              </li>
              <button class="curve-btn" @click="openActualData(l01Info, 'dropInfo')">
                实时曲线
              </button>
            </div>
            <div class="infos_con" v-if="deviceInfo.deviceName.indexOf('DC') != -1">
              <li class="infos_item">01导线偏磁：{{ l01Info.magnetic || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l01Info, 'magnetic')">
                实时曲线
              </button>
            </div>
          </ul>
          <ul class="two_info infos" v-if="l02Info" :class="{ alarm_info: l02Info.status == 1 }">
            <div class="infos_con">
              <li class="infos_item">02导线电流：{{ l02Info.currentValue || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l02Info, 'currentValue')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">02导线温度：{{ l02Info.temperature || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l02Info, 'temperature')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">
                02导线线夹状态：{{
                  l02Info.dropInfo == 0 ? '正常' : l02Info.dropInfo == 1 ? '脱落' : '-'
                }}
              </li>
              <button class="curve-btn" @click="openActualData(l02Info, 'dropInfo')">
                实时曲线
              </button>
            </div>
            <div class="infos_con" v-if="deviceInfo.deviceName.indexOf('DC') != -1">
              <li class="infos_item">02导线偏磁：{{ l02Info.magnetic || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l02Info, 'magnetic')">
                实时曲线
              </button>
            </div>
          </ul>
          <ul class="pic_info">
            <header class="infos_header">线夹图片</header>
            <section class="pic_con">
              <div v-if="deviceInfo.oneImage">
                <el-image
                  :src="deviceInfo.oneImage"
                  :preview-src-list="[deviceInfo.oneImage]"
                ></el-image>
              </div>
              <div v-if="deviceInfo.twoImage">
                <el-image
                  :src="deviceInfo.twoImage"
                  :preview-src-list="[deviceInfo.twoImage]"
                ></el-image>
              </div>
            </section>
          </ul>
          <section class="deviceInfo">
            <header class="infos_header">设备信息</header>
            <ul class="deviceInfo_con form_info">
              <li>
                <span class="name">设备名称：</span>
                <div class="value">{{ deviceInfo.deviceName }}</div>
              </li>
              <li>
                <span class="name">设备编号：</span>
                <div class="value">{{ deviceInfo.deviceId }}</div>
              </li>
              <li>
                <span class="name">设备状态：</span>
                <div class="value">{{ deviceInfo.deviceStatus == 1 ? '告警' : '正常' }}</div>
              </li>
              <li>
                <span class="name">设备定位：</span>
                <div class="value">
                  <template v-if="deviceInfo.longitude && deviceInfo.latitude">
                    {{ deviceInfo.longitude }}; {{ deviceInfo.latitude }}
                  </template>
                </div>
              </li>
              <li>
                <span class="name">主机电量：</span>
                <div class="value">{{ deviceInfo.electric }}</div>
              </li>
              <li>
                <span class="name">通信质量：</span>
                <div class="value">{{ deviceInfo.dbm }}</div>
              </li>
              <li>
                <span class="name">环境温度：</span>
                <div class="value">
                  {{ deviceInfo.temperature }}{{ deviceInfo.temperature ? '℃' : '' }}
                </div>
              </li>
              <li>
                <span class="name">环境湿度：</span>
                <div class="value">
                  {{ deviceInfo.humidity }}{{ deviceInfo.humidity ? 'RH' : '' }}
                </div>
              </li>
            </ul>
          </section>
          <ul class="eleven_info infos" v-if="l11Info" :class="{ alarm_info: l11Info.status == 1 }">
            <div class="infos_con">
              <li class="infos_item">11导线电流：{{ l11Info.currentValue || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l11Info, 'currentValue')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">11导线温度：{{ l11Info.temperature || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l11Info, 'temperature')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">
                11导线线夹状态：{{
                  l11Info.dropInfo == 0 ? '正常' : l11Info.dropInfo == 1 ? '脱落' : '-'
                }}
              </li>
              <button class="curve-btn" @click="openActualData(l11Info, 'dropInfo')">
                实时曲线
              </button>
            </div>
            <div class="infos_con" v-if="deviceInfo.deviceName.indexOf('DC') != -1">
              <li class="infos_item">11导线偏磁：{{ l11Info.magnetic || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l11Info, 'magnetic')">
                实时曲线
              </button>
            </div>
          </ul>
          <ul
            class="tweleve_info infos"
            v-if="l12Info"
            :class="{ alarm_info: l12Info.status == 1 }"
          >
            <div class="infos_con">
              <li class="infos_item">12导线电流：{{ l12Info.currentValue || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l12Info, 'currentValue')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">12导线温度：{{ l12Info.temperature || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l12Info, 'temperature')">
                实时曲线
              </button>
            </div>
            <div class="infos_con">
              <li class="infos_item">
                12导线线夹状态：{{
                  l12Info.dropInfo == 0 ? '正常' : l12Info.dropInfo == 1 ? '脱落' : '-'
                }}
              </li>
              <button class="curve-btn" @click="openActualData(l12Info, 'dropInfo')">
                实时曲线
              </button>
            </div>
            <div class="infos_con" v-if="deviceInfo.deviceName.indexOf('DC') != -1">
              <li class="infos_item">12导线偏磁：{{ l12Info.magnetic || '-' }}</li>
              <button class="curve-btn" @click="openActualData(l12Info, 'magnetic')">
                实时曲线
              </button>
            </div>
          </ul>
          <ul class="wd_info form_info">
            <li>
              <span class="name">舞动幅度：</span>
              <div class="value">{{ deviceInfo.scope }}</div>
              <button @click="openActualData(deviceInfo, 'scope')">
                实时曲线
              </button>
            </li>
            <li>
              <span class="name">舞动频率：</span>
              <div class="value">{{ deviceInfo.frequency }}</div>
              <button @click="openActualData(deviceInfo, 'frequency')">
                实时曲线
              </button>
            </li>
          </ul>
          <span class="sendTime">数据上报时间：{{ deviceInfo.sendTime }}</span>
        </div>
      </div>
    </transition>
    <actualData v-model="showActualData" :data="deviceInfo" :line="line" :type="type"></actualData>
  </div>
</template>

<script>
  import actualData from './actualData'
  export default {
    components: {
      actualData
    },
    props: {
      // 控制弹窗显示隐藏
      visible: {
        type: Boolean,
        default: false
      },
      deviceCode: {
        type: String,
        default: ''
      }
    },
    watch: {
      visible: {
        handler(newVal) {
          if (newVal) {
            document.body.style.overflow = 'hidden'
            this.getDeviceInfo(this.deviceCode)
          } else {
            document.body.style.overflow = ''
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        deviceInfo: {},
        subDataList: [],
        showActualData: false,
        line: '',
        type: ''
      }
    },
    computed: {
      l01Info() {
        return this.subDataList.find(item => item.line.indexOf('01') != -1)
      },
      l02Info() {
        return this.subDataList.find(item => item.line.indexOf('02') != -1)
      },
      l11Info() {
        return this.subDataList.find(item => item.line.indexOf('11') != -1)
      },
      l12Info() {
        return this.subDataList.find(item => item.line.indexOf('12') != -1)
      }
    },
    methods: {
      openActualData(info, type) {
        this.type = type
        if (type == 'scope' || type == 'frequency') {
          this.line = ''
        } else {
          this.line = info.line
        }
        this.showActualData = true
      },
      getDeviceInfo(code) {
        this.$axiosget(`operation/gapStick/getDetail?deviceId=${code}`).then(res => {
          if (res.data.status == 10000) {
            this.deviceInfo = res.data.data
            this.subDataList = res.data.data.subDataList || []
            this.deviceInfo.oneImage = res.data.data.bigImage1
              ? 'data:image/png;base64,' + res.data.data.bigImage1
              : ''
            this.deviceInfo.twoImage = res.data.data.bigImage2
              ? 'data:image/png;base64,' + res.data.data.bigImage2
              : ''
          }
        })
      },
      handleClose() {
        this.$emit('update:visible', false)
        this.$emit('close')
      },
      handleCancel() {
        this.$emit('update:visible', false)
        this.$emit('cancel')
      },
      handleConfirm() {
        this.$emit('confirm')
      },
      handleOverlayClick() {
        if (this.closeOnClickOverlay) {
          this.handleClose()
        }
      }
    },
    beforeDestroy() {
      document.body.style.overflow = ''
    }
  }
</script>

<style lang="less" scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .modal-content {
      width: 16.24rem;
      height: 81.27vh;
      background-image: url('../img/modal_bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 0.27rem;
      animation: slideDown 0.3s ease-out;
      position: relative;

      .modal_img {
        position: absolute;
        top: 10.29vh;
        left: 3.97rem;
        width: 8.09rem;
        height: 57.6vh;
      }

      .infos {
        position: absolute;
        width: 2.97rem;
        min-height: 15.02vh;
        background-image: url('../img/common_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1.6vh 0.23rem;

        .infos_con {
          display: flex;
          justify-content: center;
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 0.8vh;
          }
        }

        li {
          width: 1.7rem;
          height: 3.89vh;
          background-color: #279ff3;
          border-radius: 0.06rem;
          font-family: MicrosoftYaHei;
          font-size: 1.45vh;
          color: #fff;
          text-align: center;
          line-height: 3.89vh;
        }

        .curve-btn {
          width: 0.72rem;
          height: 3.89vh;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          border: none;
          border-radius: 0.06rem;
          font-family: MicrosoftYaHei;
          font-size: 1.4vh;
          color: #fff;
          padding: 0;
          cursor: pointer;
          outline: none;
          margin-left: 0.1rem;
        }
      }

      .alarm_info {
        background-image: url('../img/common_alarm_bg.png');
      }

      .one_info {
        left: 0.92rem;
        top: 4.23vh;
      }

      .two_info {
        right: 0.92rem;
        top: 4.23vh;
      }

      .eleven_info {
        left: 0.92rem;
        bottom: 11.44vh;
      }

      .tweleve_info {
        right: 0.92rem;
        bottom: 11.44vh;
      }

      .form_info {
        li {
          display: flex;
          justify-content: center;
          align-items: center;

          &:first-child {
            margin-right: 0.1rem;
          }

          span {
            font-family: MicrosoftYaHei;
            font-size: 1.3vh;
            color: #6fb5ff;
          }

          div {
            width: 0.89rem;
            height: 2.41vh;
            padding-left: 0.14rem;
            border: 1px solid #4898e5;
            font-family: MicrosoftYaHei;
            font-size: 1.3vh;
            line-height: 2.41vh;
            color: #fff;
          }

          button {
            width: 0.8rem;
            height: 2.41vh;
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border: none;
            border-radius: 0.06rem;
            font-family: MicrosoftYaHei;
            font-size: 1.4vh;
            color: #fff;
            padding: 0;
            cursor: pointer;
            outline: none;
            margin-left: 0.1rem;
          }
        }
      }

      .wd_info {
        position: absolute;
        left: 4.62rem;
        bottom: 4.45vh;
        width: 5.6rem;
        height: 7.6vh;
        background-image: url('../img/wd_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.24rem;
      }

      .pic_info {
        position: absolute;
        left: 1.75rem;
        top: 29.47vh;
        width: 2.87rem;
        height: 16.22vh;
        background-image: url('../img/common_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .infos_header {
          padding-left: 0.25rem;
          height: 3.8vh;
          background-color: #00366e;
          box-shadow: inset 0px 0px 0.35rem 0px #2473ef;
          border-radius: 0.18rem 0.18rem 0px 0px;
          display: flex;
          align-items: center;
          font-family: MicrosoftYaHei;
          font-size: 1.48vh;
          color: #fff;
        }

        .pic_con {
          padding: 2.04vh 0.28rem 0 0.26rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          & > div {
            width: calc((100% - 0.1rem) / 2);
            height: 7.6vh;
            font-size: 0;
            border: 1px solid #4c74c1;

            &:first-child {
              margin-right: 0.1rem;
            }

            & > div {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .deviceInfo {
        position: absolute;
        right: 2.2rem;
        bottom: 33.17vh;
        width: 4.93rem;
        height: 18.63vh;
        background-image: url('../img/info_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .infos_header {
          padding-left: 0.25rem;
          height: 3.8vh;
          background-color: #00366e;
          box-shadow: inset 0px 0px 0.35rem 0px #2473ef;
          border-radius: 0.18rem 0.18rem 0px 0px;
          display: flex;
          align-items: center;
          font-family: MicrosoftYaHei;
          font-size: 1.48vh;
          color: #fff;
        }

        &_con {
          padding: 1.67vh 0.3rem 0 0.21rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;

          li {
            margin-bottom: 0.74vh;
            div {
              width: 1.42rem;
            }
          }
        }
      }

      .sendTime {
        position: absolute;
        right: 0.53rem;
        bottom: 0.33rem;
        font-family: MicrosoftYaHei;
        font-size: 1.3vh;
        color: #fff;
      }
    }

    @keyframes slideDown {
      from {
        transform: translateY(-50px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/infoModal.vue